import React from 'react'

interface CustomTableDataProps {
  imageUrl?: string
  dataLabel?: string
  children?: React.ReactNode
  text?: React.ReactNode
  className?: string
}

const CustomTableData: React.FC<CustomTableDataProps> = ({
  imageUrl,
  dataLabel,
  text,
  children,
  className = '',
}) => {
  // normalize text for alt and simple display when text is a primitive
  const primitiveText = typeof text === 'string' || typeof text === 'number' ? String(text) : ''
  const textClass = `${className}`

  return (
    <td data-label={dataLabel} className={textClass}>
      {imageUrl ? (
        <div className="flex gap-5 justify-start flex-row-reverse sm:flex-row items-start sm:items-center">
          <div className="rounded-lg overflow-hidden w-10 min-w-6 h-10">
            <img src={imageUrl} alt={primitiveText || 'Image'} className="w-full h-full object-cover" />
          </div>
          {text ? <div>{text}</div> : <p className="text-ellipsis">{primitiveText}</p>}
        </div>
      ) : children ? (
        children
      ) : (
        // if text is JSX it will render; if primitive it will render too
        <>{text ?? primitiveText}</>
      )}
    </td>
  )
}

export default CustomTableData
